import React from 'react';
import { ArrowBack } from '@mui/icons-material';
import { ArrowButtonWrap } from './styled';

const DIRECTIONS = {
	right: { transform: 'rotate(180deg)' },
	up: { transform: 'rotate(90deg)' },
	down: { transform: 'rotate(270deg)' },
	left: {},
};

interface ArrowButtonProps {
	onClick: () => void;
	direction?: keyof typeof DIRECTIONS;
}

function ArrowButton({ onClick, direction = 'left' }: ArrowButtonProps) {

	return (
		<ArrowButtonWrap onClick={onClick}>
			<ArrowBack color="primary" sx={{ fontSize: '12px', ...DIRECTIONS[direction] }} />
		</ArrowButtonWrap>
	);
}

export default ArrowButton;
